import React, { useState } from "react";

const GuestPopup = ({
  isOpen,
  setIsOpen,
  adults,
  setAdults,
  children,
  setChildren,
}) => {
  return (
    <div className="relative">
      {isOpen && (
        <div className="fixed  inset-0 font-jt flex h-screen items-center justify-center z-[100000] backdrop-blur-sm bg-black bg-opacity-50">
          <div className="relative bg-white flex flex-col p-4 w-[90vw] space-y-4 rounded-2xl">
            <div className="w-full  flex items-end text-end justify-end text-black">
              <button onClick={() => setIsOpen(!isOpen)}>
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0001 1.41666C13.918 1.41666 10.9051 2.3306 8.34245 4.04292C5.77979 5.75524 3.78243 8.18902 2.60297 11.0365C1.4235 13.884 1.1149 17.0173 1.71618 20.0401C2.31747 23.063 3.80164 25.8397 5.98101 28.0191C8.16038 30.1984 10.9371 31.6826 13.9599 32.2839C16.9828 32.8852 20.1161 32.5766 22.9636 31.3971C25.8111 30.2176 28.2448 28.2203 29.9572 25.6576C31.6695 23.095 32.5834 20.0821 32.5834 17C32.5834 12.867 30.9416 8.90335 28.0192 5.98091C25.0967 3.05847 21.133 1.41666 17.0001 1.41666ZM23.6683 21.6651C23.8036 21.7958 23.9116 21.9521 23.9858 22.1249C24.0601 22.2978 24.0991 22.4837 24.1008 22.6718C24.1024 22.8599 24.0666 23.0464 23.9953 23.2205C23.9241 23.3946 23.8189 23.5528 23.6859 23.6858C23.5529 23.8188 23.3947 23.924 23.2206 23.9952C23.0465 24.0665 22.86 24.1023 22.6719 24.1007C22.4837 24.099 22.2979 24.06 22.125 23.9857C21.9522 23.9115 21.7959 23.8035 21.6652 23.6682L17.0001 19.0032L12.335 23.6682C12.2043 23.8035 12.048 23.9115 11.8752 23.9857C11.7023 24.06 11.5164 24.099 11.3283 24.1007C11.1402 24.1023 10.9537 24.0665 10.7796 23.9952C10.6055 23.924 10.4473 23.8188 10.3143 23.6858C10.1813 23.5528 10.0761 23.3946 10.0048 23.2205C9.93361 23.0464 9.89777 22.8599 9.8994 22.6718C9.90103 22.4837 9.94011 22.2978 10.0144 22.1249C10.0886 21.9521 10.1965 21.7958 10.3318 21.6651L14.9969 17L10.3318 12.3349C10.1965 12.2042 10.0886 12.0479 10.0144 11.8751C9.94011 11.7022 9.90103 11.5163 9.8994 11.3282C9.89777 11.1401 9.93361 10.9536 10.0048 10.7795C10.0761 10.6054 10.1813 10.4472 10.3143 10.3142C10.4473 10.1812 10.6055 10.076 10.7796 10.0047C10.9537 9.93351 11.1402 9.89767 11.3283 9.8993C11.5164 9.90094 11.7023 9.94002 11.8752 10.0143C12.048 10.0885 12.2043 10.1964 12.335 10.3317L17.0001 14.9968L21.6652 10.3317C21.7959 10.1964 21.9522 10.0885 22.125 10.0143C22.2979 9.94002 22.4837 9.90094 22.6719 9.8993C22.86 9.89767 23.0465 9.93351 23.2206 10.0047C23.3947 10.076 23.5529 10.1812 23.6859 10.3142C23.8189 10.4472 23.9241 10.6054 23.9953 10.7795C24.0666 10.9536 24.1024 11.1401 24.1008 11.3282C24.0991 11.5163 24.0601 11.7022 23.9858 11.8751C23.9116 12.0479 23.8036 12.2042 23.6683 12.3349L19.0033 17L23.6683 21.6651Z"
                    fill="#D00808"
                  />
                </svg>
              </button>
            </div>

            <div className="flex flex-row w-[100%] justify-around">
              <div className="flex  flex-row items-center">
                <div className="">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ll:mx-2 mr-1 lg:hidden block"
                  >
                    <path
                      d="M16.5 14C15 14 13.8 14.4 12.9 14.9C14.3 16.1 14.9 17.5 15 17.6L15.1 17.8V20H23.1V18C23 18 21.4 14 16.5 14Z"
                      fill="#020202"
                    />
                    <path
                      d="M16.5 12C18.433 12 20 10.433 20 8.5C20 6.567 18.433 5 16.5 5C14.567 5 13 6.567 13 8.5C13 10.433 14.567 12 16.5 12Z"
                      fill="#020202"
                    />
                    <path
                      d="M4 8.5C4 6.6 5.6 5 7.5 5C9.4 5 11 6.6 11 8.5C11 10.4 9.4 12 7.5 12C5.6 12 4 10.4 4 8.5ZM7.5 14C2.6 14 1 18 1 18V20H14V18C14 18 12.4 14 7.5 14Z"
                      fill="#020202"
                    />
                  </svg>
                </div>
                <div className="text-xl ">Adults</div>
              </div>

              <div className="  ml-5 flex items-center mr-[8px]">
                <button
                  onClick={() => {
                    if (adults > 0) setAdults(adults - 1);
                  }}
                  className=""
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className=""
                  >
                    <path
                      d="M9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9C0 4.02891 4.02891 0 9 0ZM5.625 9.84375H12.375C12.8391 9.84375 13.2188 9.46406 13.2188 9C13.2188 8.53594 12.8391 8.15625 12.375 8.15625H5.625C5.16094 8.15625 4.78125 8.53594 4.78125 9C4.78125 9.46406 5.16094 9.84375 5.625 9.84375Z"
                      fill="#020202"
                    />
                  </svg>
                </button>
                <div className="px-8">{adults}</div>
                {/* <input
                  id="adults"
                  value={adults}
                  className=" text-center appearance-none block  bg-transparent  border-transparent focus:border-transparent focus:ring-0 focus:outline-none"
                /> */}
                <button onClick={() => setAdults(adults + 1)} className="">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className=""
                  >
                    <path
                      d="M9 0.0625C7.23233 0.0625 5.50436 0.586675 4.0346 1.56874C2.56483 2.55081 1.41929 3.94665 0.742831 5.57977C0.0663725 7.21288 -0.11062 9.00992 0.234236 10.7436C0.579091 12.4773 1.43031 14.0698 2.68024 15.3198C3.93017 16.5697 5.52268 17.4209 7.25638 17.7658C8.99009 18.1106 10.7871 17.9336 12.4202 17.2572C14.0534 16.5807 15.4492 15.4352 16.4313 13.9654C17.4133 12.4956 17.9375 10.7677 17.9375 9C17.933 6.63102 16.9899 4.36037 15.3148 2.68525C13.6396 1.01013 11.369 0.0670426 9 0.0625ZM12.4375 9.6875H9.6875V12.4375C9.6875 12.6198 9.61507 12.7947 9.48614 12.9236C9.35721 13.0526 9.18234 13.125 9 13.125C8.81767 13.125 8.6428 13.0526 8.51387 12.9236C8.38494 12.7947 8.3125 12.6198 8.3125 12.4375V9.6875H5.5625C5.38017 9.6875 5.2053 9.61507 5.07637 9.48614C4.94744 9.35721 4.875 9.18234 4.875 9C4.875 8.81766 4.94744 8.6428 5.07637 8.51386C5.2053 8.38493 5.38017 8.3125 5.5625 8.3125H8.3125V5.5625C8.3125 5.38016 8.38494 5.2053 8.51387 5.07636C8.6428 4.94743 8.81767 4.875 9 4.875C9.18234 4.875 9.35721 4.94743 9.48614 5.07636C9.61507 5.2053 9.6875 5.38016 9.6875 5.5625V8.3125H12.4375C12.6198 8.3125 12.7947 8.38493 12.9236 8.51386C13.0526 8.6428 13.125 8.81766 13.125 9C13.125 9.18234 13.0526 9.35721 12.9236 9.48614C12.7947 9.61507 12.6198 9.6875 12.4375 9.6875Z"
                      fill="#020202"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex justify-around flex-row ">
              <div className=" flex flex-row items-center">
                <div>
                  <svg
                    width="24"
                    height="24"
                    className="ll:mx-2 "
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 7.21875C12.0102 7.21875 13.2344 5.99453 13.2344 4.48438C13.2344 2.97422 12.0102 1.75 10.5 1.75C8.98985 1.75 7.76562 2.97422 7.76562 4.48438C7.76562 5.99453 8.98985 7.21875 10.5 7.21875Z"
                      fill="#020202"
                    />
                    <path
                      d="M12.4687 13.6719C12.4687 13.6938 12.4687 13.7156 12.4687 13.7375C11.7031 13.8031 11.1344 14.4375 11.1562 15.2031C11.1562 15.4219 11.2219 15.6406 11.3312 15.8156C11.0906 15.9031 10.7844 15.9469 10.4562 15.9469C10.1062 15.9469 9.82187 15.9031 9.60312 15.8156C9.93124 15.3344 9.93124 14.6781 9.58124 14.175C9.31874 13.825 8.94687 13.6063 8.53124 13.5625V13.125H12.4687V13.6719ZM16.6687 9.66875L12.9062 7.7C12.8187 7.67813 12.7312 7.65625 12.6437 7.65625H8.53124C8.42187 7.65625 8.33436 7.67813 8.22499 7.7L4.28749 9.8875C3.82812 10.0625 3.60937 10.5656 3.76249 11.0031C3.89374 11.375 4.24374 11.5938 4.59374 11.5938C4.70312 11.5938 4.79062 11.5719 4.89999 11.55L7.65624 10.1063C7.65624 10.1063 7.65624 13.7156 7.65624 13.7812C7.61249 13.8031 5.86249 15.0281 5.86249 15.0281C5.49062 15.2906 5.38124 15.8156 5.62187 16.2094L7.15312 18.6156C7.41562 19.0312 7.96249 19.1406 8.35624 18.8781C8.74999 18.6156 8.88124 18.0688 8.61874 17.675L7.87499 16.4719H8.35624C8.50937 16.4719 8.66249 16.45 8.81562 16.4062C9.20937 16.6688 9.73437 16.8219 10.4344 16.8219C11.0906 16.8219 11.6156 16.6687 12.0312 16.45C12.2062 16.5375 12.425 16.5594 12.6437 16.5594L13.0375 16.5375L12.25 17.6312C11.9656 18.025 12.0531 18.5719 12.4469 18.8562C12.8406 19.1406 13.3875 19.0531 13.6719 18.6594L15.4219 16.2531C15.4437 16.2313 15.4656 16.2094 15.4656 16.1656C15.7062 15.75 15.5531 15.2031 15.1375 14.9625L13.3437 13.9562C13.3437 13.8687 13.3437 10.0187 13.3437 10.0187L16.1437 11.3531C16.2312 11.375 16.3187 11.3969 16.4062 11.3969C16.7781 11.3969 17.1281 11.1562 17.2375 10.7844C17.3906 10.3031 17.1281 9.82188 16.6687 9.66875Z"
                      fill="#020202"
                    />
                  </svg>
                </div>
                <div className="text-xl ">Children</div>
              </div>

              <div className=" ml-2 flex   items-center mr-2 ">
                <button
                  onClick={() => {
                    if (children > 0) setChildren(children - 1);
                  }}
                  className=""
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className=""
                  >
                    <path
                      d="M9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9C0 4.02891 4.02891 0 9 0ZM5.625 9.84375H12.375C12.8391 9.84375 13.2188 9.46406 13.2188 9C13.2188 8.53594 12.8391 8.15625 12.375 8.15625H5.625C5.16094 8.15625 4.78125 8.53594 4.78125 9C4.78125 9.46406 5.16094 9.84375 5.625 9.84375Z"
                      fill="#020202"
                    />
                  </svg>
                </button>
                <div className="px-8">{children}</div>
                {/* <input
                  id="children"
                  value={children}
                  className="text-center appearance-none   bg-transparent  border-transparent focus:border-transparent focus:ring-0 focus:outline-none"
                /> */}
                <button onClick={() => setChildren(children + 1)} className="">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className=""
                  >
                    <path
                      d="M9 0.0625C7.23233 0.0625 5.50436 0.586675 4.0346 1.56874C2.56483 2.55081 1.41929 3.94665 0.742831 5.57977C0.0663725 7.21288 -0.11062 9.00992 0.234236 10.7436C0.579091 12.4773 1.43031 14.0698 2.68024 15.3198C3.93017 16.5697 5.52268 17.4209 7.25638 17.7658C8.99009 18.1106 10.7871 17.9336 12.4202 17.2572C14.0534 16.5807 15.4492 15.4352 16.4313 13.9654C17.4133 12.4956 17.9375 10.7677 17.9375 9C17.933 6.63102 16.9899 4.36037 15.3148 2.68525C13.6396 1.01013 11.369 0.0670426 9 0.0625ZM12.4375 9.6875H9.6875V12.4375C9.6875 12.6198 9.61507 12.7947 9.48614 12.9236C9.35721 13.0526 9.18234 13.125 9 13.125C8.81767 13.125 8.6428 13.0526 8.51387 12.9236C8.38494 12.7947 8.3125 12.6198 8.3125 12.4375V9.6875H5.5625C5.38017 9.6875 5.2053 9.61507 5.07637 9.48614C4.94744 9.35721 4.875 9.18234 4.875 9C4.875 8.81766 4.94744 8.6428 5.07637 8.51386C5.2053 8.38493 5.38017 8.3125 5.5625 8.3125H8.3125V5.5625C8.3125 5.38016 8.38494 5.2053 8.51387 5.07636C8.6428 4.94743 8.81767 4.875 9 4.875C9.18234 4.875 9.35721 4.94743 9.48614 5.07636C9.61507 5.2053 9.6875 5.38016 9.6875 5.5625V8.3125H12.4375C12.6198 8.3125 12.7947 8.38493 12.9236 8.51386C13.0526 8.6428 13.125 8.81766 13.125 9C13.125 9.18234 13.0526 9.35721 12.9236 9.48614C12.7947 9.61507 12.6198 9.6875 12.4375 9.6875Z"
                      fill="#020202"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestPopup;
